export enum ApproverType {
  User = 0,
  SystemProcess
  // PrivilegePages
}
